import React, { useMemo } from 'react';
import Icon from '../Icon';
import clsx from 'clsx';

const Toast = ({ title, text, type = 'default' }) => {
  const iconName = useMemo(() => {
    switch (type) {
      case 'default':
      case 'info':
      default:
        return 'Info';
      case 'success':
        return 'Check-Circle';
      case 'error':
      case 'warning':
        return 'Caution-Circle-Filled';
    }
  }, [type]);

  const backgroundColor = useMemo(() => {
    switch (type) {
      case 'default':
      default:
        return 'toast--bg-white';
      case 'info':
        return 'toast--bg-primary-50';
      case 'success':
        return 'toast--bg-success-50';
      case 'error':
        return 'toast--bg-error-50';
      case 'warning':
        return 'toast--bg-warning-50';
    }
  }, [type]);

  const iconColor = useMemo(() => {
    switch (type) {
      case 'default':
      default:
        return 'toast__icon--gray-900';
      case 'info':
        return 'toast__icon--primary-500';
      case 'success':
        return 'toast__icon--success-500';
      case 'error':
        return 'toast__icon--error-500';
      case 'warning':
        return 'toast__icon--warning-500';
    }
  }, [type]);

  return (
    <div className={clsx('toast', backgroundColor)}>
      <div className="toast__icon-wrapper">
        <Icon name={iconName} size={24} className={iconColor} />
      </div>
      <div className="toast__text-wrapper">
        {title && <div className="toast__title">{title}</div>}
        {text && <div className="toast__text">{text}</div>}
      </div>
    </div>
  );
};

export default Toast;
